@let showFilterDrawer = isFilterDrawerVisible$ | async;
<div
  data-test-id="wilson-timeline-filter:filter-icon"
  class="filter-icon d-flex justify-content-center align-items-center"
  [ngClass]="showFilterDrawer ? 'filter-icon-open' : 'filter-icon-close'"
  (click)="toggleFilterDrawer(!!showFilterDrawer)"
>
  <fa-icon [icon]="faFilter"></fa-icon>
  @let numberOfParams = (numberOfParams$ | async) ?? 0;
  @if (numberOfParams > 0) {
    <nz-badge
      [nzCount]="numberOfParams"
      class="filter-counter"
      [attr.data-test-id]="'timeline-filter:badge:' + numberOfParams"
    >
    </nz-badge>
  }
</div>

<div
  class="filter-section"
  [ngClass]="showFilterDrawer ? 'filter-open' : 'filter-close'"
>
  <div class="show-filters" [ngClass]="{ 'hide-filters': !showFilterDrawer }">
    <div class="filter-container ps-4 pe-3 pb-3">
      <wilson-user-filters-group></wilson-user-filters-group>
      <wilson-shift-filters-group></wilson-shift-filters-group>
      <wilson-absence-filters-group></wilson-absence-filters-group>
    </div>
    <div class="d-flex flex-column px-4 pt-3 clear-filters-container">
      <wilson-clear-timeline-filters-button></wilson-clear-timeline-filters-button>
    </div>
  </div>
</div>
